// extracted by mini-css-extract-plugin
module.exports = {"wrapperDialog":"social-dialog_wrapperDialog__edQme","panelDialog":"social-dialog_panelDialog___jgMV","IFrame":"social-dialog_IFrame__cVM_Q"};